import React from "react";
import styled from "styled-components";

const RecommendationsContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
`;

const RecommendationsTitle = styled.h3`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
`;

const RecommendationsList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const RecommendationItem = styled.li`
  background-color: #f8f9fa;
  border-left: 4px solid #6ed216;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 0 5px 5px 0;
  font-size: 16px;
  line-height: 1.5;
`;

function Recommendations({ recommendations }) {
  return (
    <RecommendationsContainer>
      <RecommendationsTitle>
        Recommandations pour vos prochaines campagnes
      </RecommendationsTitle>

      {recommendations.length > 0 ? (
        <RecommendationsList>
          {recommendations.map((recommendation, index) => (
            <RecommendationItem key={index}>
              {recommendation}
            </RecommendationItem>
          ))}
        </RecommendationsList>
      ) : (
        <p style={{ textAlign: "center", color: "#666" }}>
          Aucune recommandation disponible pour cette campagne.
        </p>
      )}
    </RecommendationsContainer>
  );
}

export default Recommendations;
